import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewsHeading: {
		id: 'polaris-ideas.sidebar.sections.views-heading',
		defaultMessage: 'VIEWS',
		description: 'Section heading for Views',
	},
});
